import AdhereLogo from "../../../assets/adhere-logo.svg";
import SeequreLogo from "../../../assets/seequre-logo.svg";
import OculusLogo from "../../../assets/oculus-logo.svg";
import AcademyLogo from "../../../assets/academy-logo.svg";
import CenterLogo from "../../../assets/smartcomply-logo.svg";

export default function Divisions() {
  return (
    <div className="w-full max-w-6xl mx-auto">
      <svg
        viewBox="0 100 1000 400"
        className="w-full h-auto"
        xmlns="http://www.w3.org/2000/svg"
      >
        {/* Glow */}
        <defs>
          <filter id="blur">
            <feGaussianBlur stdDeviation="60" />
          </filter>
        </defs>
        {/* 
        <ellipse
          cx="500"
          cy="300"
          rx="220"
          ry="90"
          fill="#A3B6FF"
          opacity="0.6"
          filter="url(#blur)"
        /> */}

        {/* CONNECTORS */}
        <AnimatedLine d="M260 210 H340 V260 H420 V300 H500" />
        <AnimatedLine d="M740 210 H660 V260 H580 V300 H500" />
        <AnimatedLine d="M260 390 H340 V340 H420 V300 H500" />
        <AnimatedLine d="M740 390 H660 V340 H580 V300 H500" />

        {/* CENTER */}
        <image href={CenterLogo} x="355" y="215" width="290" height="170" />

        {/* TOP LEFT */}
        <image href={AdhereLogo} x="160" y="140" width="200" height="140" />

        {/* TOP RIGHT */}
        <image href={OculusLogo} x="640" y="140" width="200" height="140" />

        {/* BOTTOM LEFT */}
        <image href={SeequreLogo} x="160" y="320" width="200" height="140" />

        {/* BOTTOM RIGHT */}
        <image href={AcademyLogo} x="640" y="320" width="200" height="140" />
      </svg>
    </div>
  );
}

function AnimatedLine({ d }) {
  return (
    <path
      d={d}
      fill="none"
      stroke="#1E3A8A"
      strokeWidth="2"
      strokeDasharray="2 8"
      strokeLinecap="round"
      className="animate-dash"
    />
  );
}
